import { useTranslation } from 'react-i18next';
import { navigate } from 'gatsby';
import { Button } from '@opswat/ui';
import notFound from 'images/notFound.svg';

export const RoleAccessDenied = () => {
    const { t } = useTranslation();

    return (
        <div className='tw:flex tw:flex-col tw:justify-center tw:items-center tw:w-full tw:h-full tw:m-auto'>
            <img src={notFound} draggable={false} alt={t('Access Denied')} />
            <div className='tw:flex tw:flex-col tw:gap-32 tw:justify-between'>
                <div className='tw:md:w-580 tw:px-10 tw:flex tw:flex-col tw:gap-9 tw:justify-between tw:text-center'>
                    <span className='tw:text-headline'>{t('Access Denied')}</span>
                    <span className='tw:text-body tw:text-neutrals-800 tw:dark:text-neutrals-500'>
                        {t(
                            'You do not have permission to access this page. Please contact your administrator if you believe this is an error.',
                        )}
                    </span>
                    <div className='tw:flex tw:justify-center tw:mt-6'>
                        <Button id='error-role-access-denied-go-home' variant='primary' onClick={() => navigate('/')}>
                            {t('Go to Homepage')}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};
